export default __webpack_public_path__ + "static/media/leaves.f156bd77.svg";